module.exports = "/_next/static/images/collaborate@3x-c811b183aa37961869aa911d8e944714.png";